"use client";

import { useCheckoutContext, useCheckoutRefresh } from "../../Checkout.hooks";
import {
  useWalleyCheckoutEvents,
  useWalleyCheckoutMount,
} from "./Walley.hooks";

export default function WalleyWidget({ snippet }: { snippet?: string }) {
  const { walleyWidgetRef } = useCheckoutContext();

  useWalleyCheckoutMount({ ref: walleyWidgetRef, snippet });
  useWalleyCheckoutEvents(snippet);
  useCheckoutRefresh();

  return (
    <div
      ref={walleyWidgetRef}
      className="scroll-mt-[10rem] lg:scroll-mt-[12rem]"
      data-testid="walley-checkout-container"
    />
  );
}
